<template>
    <div class="layout-right" ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="卡项管理-详情"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="card-info-box">
                <el-tabs v-model="tabIndex" type="card" class="flex flex-v flex-1">
                    <el-tab-pane name="0" label="卡项权益">
                        <card-product-list :card-id="tabProId" />
                    </el-tab-pane>
                    <!--<el-tab-pane name="1" label="销售记录">-->
                        <!--<card-sale-history :card-id="tabSaleId" />-->
                    <!--</el-tab-pane>-->
                    <el-tab-pane name="2" label="历史记录">
                        <card-edit-history :card-id="tabEditId" />
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import RightTop from "@/model/RightTop";
    import CardProductList from "@/model/Card/CardProductList";
    import CardEditHistory from "@/model/Card/CardEditHistory";
    import CardSaleHistory from "@/model/Card/CardSaleHistory";
    export default {
        name: "CardInfo",
        components: {CardSaleHistory, CardEditHistory, CardProductList, RightTop},
        props: {
            id: {
                type: [Number,String],
                default: 0
            },
        },
        data: () => ({
            tabIndex: "0",
            tabProId: "",       //卡项权益的ID
            tabSaleId: "",      //销售记录ID
            tabEditId: "",      //编辑记录ID
        }),
        mounted: function () {
            this.$store.commit("setMenuId", "9-1");
            this.tabProId = this.id;
        },
        watch: {
            tabIndex: function (newData) {
                if(newData === "0")
                    this.tabProId = this.id;
                else if(newData === "1")
                    this.tabSaleId = this.id;
                else if(newData === "2")
                    this.tabEditId = this.id;
            }
        }
    }
</script>

<style scoped>
    .card-info-box{
        background: #FFFFFF;
        padding: 16px;
    }
</style>
